import { reducer as location } from '../routes';

export default location;

const initialLocationQuery = {
  curated: true,
  tara: true,
};

export const getLocation = state => state.location;
export const getLocationType = state => state.location.type;
export const getLocationPayload = state => state.location.payload;
export const getLocationPrev = state => state.location.prev;
export const getLocationQuery = state => state.location.query || initialLocationQuery;



// WEBPACK FOOTER //
// ./src/reducers/location.js